import { render, staticRenderFns } from "./myFavor.vue?vue&type=template&id=4a338c3e&scoped=true"
import script from "./myFavor.vue?vue&type=script&lang=js"
export * from "./myFavor.vue?vue&type=script&lang=js"
import style0 from "./myFavor.vue?vue&type=style&index=0&id=4a338c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a338c3e",
  null
  
)

export default component.exports